import ModelBuilder from 'helpers/ModelBuilder';

export class Vehicle {
  type: string;
  lengthRange: string;
  slides: string[];
  towing: string;
  electrical: string[];

  static Model: typeof ModelDefinition;
};

const fields = ModelBuilder.buildFormFields<Vehicle>({
  type: { label: 'RV Type', info: 'Select the guest’s RV type.' },
  lengthRange: { label: 'RV Size', info: 'Select the guest’s RV length (in feet).' },
  slides: { label: 'RV Slide', info: 'Select the guest’s RV slide out configuration.', type: 'multiple' },
  towing: { label: 'Towing', info: 'Select the guest’s RV towing vehicle. ' },
  electrical: { label: 'Electrical Service', info: 'Select the guest’s RV electrical service requirements. ', type: 'multiple' },
})

class ModelDefinition {
  static fields = fields;
}
Vehicle.Model = ModelDefinition;
